import { defineStore } from 'pinia'

export const useBridgeStore = defineStore('bridge', {
  state: () => ({
    scopedToken: null,
    apiUrl: null,
    projectCode: null,
    userId: null,
    agentCode: null,
    sessionContext: null,
  }),
  actions: {
    init({ scopedToken, apiUrl, projectCode, userId, agentCode, sessionContext }) {
      this.scopedToken = scopedToken ?? null
      this.apiUrl = apiUrl ?? null
      this.projectCode = projectCode ?? null
      this.userId = userId ?? null
      this.agentCode = agentCode ?? null
      this.sessionContext = sessionContext ?? null
    },
    /** Swap in a refreshed token without touching the rest of the context. */
    setScopedToken(token) {
      this.scopedToken = token ?? null
    },
  },
  getters: {
    isReady: (state) => !!(state.scopedToken && state.apiUrl && state.projectCode),
  },
})
